/* ------------------------------------------------------------------------
   Vista previa fija del volante · rollout del test R4 (sep 2026)
   Anade bajo la galeria una imagen grande de la opcion elegida y la mantiene
   a la vista mientras el comprador recorre los grupos de opciones, que en
   este producto son veinte.

   Diferencias con el codigo del test:
   1. Espera a que la app de opciones (Globo) inyecte los swatches, en vez de
      apostar 5 segundos fijos. Con conexion lenta el original no aparecia.
   2. Resuelve el grupo por su etiqueta (Shape / Style / Model) en vez de un
      identificador escrito a mano, que cambia en cada producto.
   3. El scroll usa requestAnimationFrame y listener pasivo, y el ancho se
      recalcula al redimensionar.
   Solo escritorio: el corte de 990px coincide con el media query del CSS.
------------------------------------------------------------------------ */
(function () {
  'use strict';

  var DESKTOP = '(min-width: 990px)';
  var MAIN_IMAGE = '.grid__item.medium-up--one-half.product-single__sticky';

  function findGroup() {
    var groups = document.querySelectorAll('.gpo-element[data-element-id^="image-swatches"]');
    for (var i = 0; i < groups.length; i++) {
      var label = groups[i].querySelector('.label-content');
      if (label && /shape|style|model/i.test(label.textContent)) return groups[i];
    }
    return groups.length ? groups[0] : null;
  }

  function mount(holder) {
    var mainImage = document.querySelector(MAIN_IMAGE);
    if (!mainImage || document.querySelector('.wheel-image')) return;

    var wheelImage = document.createElement('div');
    wheelImage.className = 'wheel-image';
    wheelImage.style.width = mainImage.offsetWidth + 'px';
    mainImage.appendChild(wheelImage);

    function updateWheelImage(input) {
      var swatch = input.closest('.gpo-swatches');
      var img = swatch && swatch.querySelector('label img');
      if (!img || !img.getAttribute('src')) return;
      var title = swatch.querySelector('.gpo-tooltip__title');
      var el = document.createElement('img');
      el.src = img.getAttribute('src').split('?')[0];
      el.alt = title ? title.textContent.trim() : 'Selected option';
      wheelImage.innerHTML = '';
      wheelImage.appendChild(el);
    }

    var checked = holder.querySelector('input[type="radio"]:checked');
    if (checked) updateWheelImage(checked);

    holder.addEventListener('change', function (e) {
      if (e.target.matches('input[type="radio"]')) updateWheelImage(e.target);
    });

    var container = document.querySelector('.page-content--product');
    if (!container) return;

    var isDesktop = window.matchMedia(DESKTOP);
    var wheelStartOffset = wheelImage.getBoundingClientRect().top + window.scrollY;
    var ticking = false;

    function place() {
      ticking = false;
      if (!isDesktop.matches) {
        wheelImage.style.position = 'static';
        return;
      }
      var scrollY = window.scrollY;
      var containerBottom = container.offsetTop + container.offsetHeight;
      var stopPoint = containerBottom - wheelImage.offsetHeight - 100;

      if (scrollY > wheelStartOffset && scrollY < stopPoint) {
        wheelImage.style.position = 'fixed';
        wheelImage.style.top = '100px';
        wheelImage.style.bottom = 'auto';
      } else if (scrollY >= stopPoint) {
        wheelImage.style.position = 'absolute';
        wheelImage.style.top = (stopPoint - wheelStartOffset) + 'px';
      } else {
        wheelImage.style.position = 'static';
      }
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(place);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      wheelImage.style.position = 'static';
      wheelImage.style.width = mainImage.offsetWidth + 'px';
      wheelStartOffset = wheelImage.getBoundingClientRect().top + window.scrollY;
      place();
    });

    place();
  }

  function start() {
    var holder = findGroup();
    if (!holder) return false;
    mount(holder);
    return true;
  }

  if (!document.querySelector(MAIN_IMAGE)) return;
  if (start()) return;

  var observer = new MutationObserver(function () {
    if (start()) observer.disconnect();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  setTimeout(function () { observer.disconnect(); }, 20000);
})();
